import React, { useState } from 'react';
import styled from 'styled-components';
import { object as yupObject, string as yupString } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, useForm } from 'react-hook-form';
import { Dialog, ElevatedButton, TextButton } from '@producer/ui-kit';

import { DepartmentSelect } from './department-select';
import { Team } from '../../../app/entities/team';

interface CreateNewDepartmentModalProps {
  team: Team;
  onClose: () => void;
  onCancel: () => void;
}

export const CreateNewDepartmentModal: React.FC<CreateNewDepartmentModalProps> = ({
  team,
  onClose,
  onCancel,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const schema = yupObject().shape({
    departmentName: yupString()
      .matches(/^(.*)?\S+(.*)?$/, 'Department is required')
      .required('Department is required'),
  });

  const { handleSubmit, control } = useForm<{ departmentName: string }>({
    resolver: yupResolver(schema),
    mode: 'onSubmit',
  });

  const onSubmit = async (values: { departmentName: string }) => {
    if (isLoading) return;
    setIsLoading(true);

    try {
      await team.addDepartment(values.departmentName);
      setIsLoading(false);
      onClose();
    } catch (e) {
      setIsLoading(false);
    }
  };

  return (
    <Dialog
      title={'Create Department'}
      onClose={onClose}
      actions={[
        <TextButton key="cancel" text="Cancel" onClick={onCancel} />,
        <ElevatedButton
          key="add"
          form="add-department-form"
          type="submit"
          isLoading={isLoading}
          text={'Add'}
        />,
      ]}
    >
      <form id="add-department-form" onSubmit={handleSubmit(onSubmit)}>
        <Label>Name</Label>
        <Controller
          control={control}
          name="departmentName"
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <DepartmentSelect
              value={value}
              onChange={onChange}
              errorMessage={error?.message}
            />
          )}
        />
      </form>
    </Dialog>
  );
};

const Label = styled.label`
  display: inline-block;
  font-weight: 600;
  color: white;
  line-height: 1.1rem;
  margin-bottom: 1.2rem;
`;
